import React, { useMemo, useRef, useState } from 'react';
import {
    Box,
    Button,
    Divider,
    FormControl,
    IconButton,
    InputLabel,
    MenuItem,
    Modal,
    Paper,
    Select,
    Slider,
    Stack,
    TextField,
    Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';
import { styled } from '@mui/material/styles';
import { useThemeContext } from '../../hook/useThemeManager';
import { theme } from '../../constants/theme';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { DndContext, closestCenter, PointerSensor, useSensor, useSensors, DragEndEvent } from '@dnd-kit/core';
import { useDraggable } from '@dnd-kit/core';

const WRATHE_PATH =
    'M464.16,551.88c-.17,13.01-1.64,27.57.99,39.45.99,4.48-.38,10.24,1.97,13.31v-.49c4.41-4.73,6.4-12.16,9.86-17.75,9.75-15.72,22.25-33.26,41.43-39.45,7.39-2.38,17.04-2.02,26.63-1.97-.65,7.41-7.45,17.22-10.85,22.69-13.66,21.96-31.1,41.97-66.58,41.92,0,5.28,1.76,10.08,2.96,14.3,2.86,10.11,4.59,19.3,8.38,28.11.4-.5.17-.13.49-.99,2.13-1.74,2.46-4.45,3.95-6.9,4.31-7.1,7.4-15.44,11.83-22.68,7.35-12,16.45-23.39,30.08-29.1,7.66-3.21,17.35-2.71,26.63-4.44v.99c-2.62,3.74-4.38,13.09-6.41,17.75-5.97,13.7-16.44,28.31-28.11,36.49-6.31,4.43-14.28,7.07-22.68,9.37-4.57,1.25-11.38.4-14.79,2.96,3.34,3.85,4.51,10.69,6.9,15.29,4.81,9.26,10.61,18.08,15.29,27.12.4-.5.18-.14.49-.99,4.91-6.39,5.57-19.98,8.38-28.6,6.54-20.05,19.7-39.61,46.36-39.45-.78,6.19-3.94,12.3-5.92,17.75-1.38,3.8-1.46,7.2-2.96,10.85-4.78,11.66-12.03,24.65-21.7,31.56-4.25,3.04-9.91,5.79-14.79,7.89-2.93,1.26-6.19,1.5-8.38,3.45,3.27,3.28,5.19,7.99,7.89,11.84,3.86,5.49,8.85,10.45,12.82,15.78,2.1,2.82,3.99,6.42,6.9,8.38.11-3.34.83-6.88,1.48-9.86,1.79-8.19-.98-16.77.99-24.17,5.35-20.11,15.79-35.12,36.99-39.45v3.95c-2.03,3.35.03,13.15-.99,17.75-1.99,9.01-3.31,17.65-7.4,24.66-4.63,7.94-11.48,15.4-18.74,20.71-3.13,2.29-9.71,4.85-10.85,8.88,3.3,2.18,6,6.22,8.38,9.37,1.81,1.64,3.62,3.29,5.42,4.93,4.93,4.93,9.86,9.86,14.79,14.79,2.07,2.07,9.14,9.88,10.85,9.86-4.53-4.76-4.61-13.71-6.41-21.21-5.93-24.68,1.83-58.23,23.67-59.18,9.38,19.82,10.65,50.73-.99,69.53-2.08,3.37-5.7,8.05-8.88,10.36-1.76,1.28-3.88,1.45-4.93,3.45,4.38,2.82,7.7,7.29,11.84,10.36,8.77,6.51,17.63,13.04,27.12,18.74v-.99c-3.85-4.09-4.28-12.02-5.92-18.25-6.48-24.72-1.86-54.81,20.22-59.18,1.96,7.23,5.39,14.66,7.4,22.69,4.04,16.16-.56,35.61-5.92,45.86-2.38,4.56-5.36,11.06-10.36,12.82.5.4.13.17.99.49,3.89,4.55,12.26,7,17.75,9.86,13.09,6.81,27.36,13.4,41.43,19.23,5.36,2.23,18.65,5.13,22.19,8.38-2.33,2.76-2.15,9.65-5.42,11.34-4.2-3.53-14.18-5.05-19.73-7.4-14.09-5.97-28.75-11.87-41.92-18.74-5.22-2.72-12.2-4.43-16.27-8.38-.87.31-.48.1-.99.49-3.97,3.19-6.2,8.74-10.36,11.83-10.64,7.92-38.1,18.57-59.18,13.81-7.59-1.71-22.83-1.44-25.64-6.9,2.59-3.38,3.8-8.36,6.41-11.83,5.48-7.3,16.71-11.52,26.63-14.3,3.12-.33,6.25-.66,9.37-.99,4.31-.96,13.66-1.62,18.74-.49,6.58.99,13.15,1.97,19.73,2.96,2.32.64,7.5,2.77,9.37,1.97h-.99c-2.9-2.86-7.32-4.19-10.85-6.41-7.93-5-15.3-11.29-22.68-16.77-3.77-2.8-8.75-5.45-11.34-9.37h-.49c-4.82,18.57-45.01,24.36-69.04,18.25-6.47-1.65-23.24-4.03-24.16-9.86,2.8-3.58,3.76-8.15,7.4-10.85,9.03-6.69,20.69-9.86,36.49-9.86h8.88c10.53,2.45,20.69,3.9,29.59,7.4,1.78.7,7.69,3.06,8.38,2.47-8.33-5.47-15.21-14.22-22.19-21.21-4.44-4.44-8.88-8.88-13.32-13.31-.16.16-.33.33-.49.49-2.01,1.36-3.47,3.57-5.43,4.93-4.73,3.3-11.13,5.72-17.26,7.4-22.17,6.06-49.85-7.04-62.14-14.79-5.69-3.59-12.36-7.04-15.78-12.82,3.83-2.99,6.55-7.19,10.85-9.86,9.4-5.83,29.69-7.44,42.9-3.45,12.61,3.8,22.82,9.78,32.55,16.27,1.59,1.06,9.27,6.13,9.37,5.92-4.32-3-7.69-8.6-10.85-12.82-9.08-12.12-19.98-23.36-27.12-37.48h-.99c-1.9,2.87-5.2,3.79-8.38,5.43-19.8,10.17-49.3,1.97-66.08-5.43-3.81-1.68-7.46-4.75-10.85-6.9-4.31-2.74-15.25-9.11-16.27-14.3,2.86-1.91,4.95-5.04,7.89-6.9,9.22-5.86,26.03-9.81,40.44-5.92,15.11,4.08,28.19,10.69,39.45,18.74,1.99,1.42,10.98,9.69,11.34,8.88-5.31-5.83-10.08-19.3-13.31-27.12-1.4-3.38-1.94-11.09-4.93-12.82-6.26,4.91-26.08,2.67-33.53.49-28.46-8.3-47.88-22.66-61.15-45.86,2.79-1.56,6.55-2.98,9.86-3.95,27.08-7.93,51.76,13.17,65.1,23.18,5.54,4.16,9.61,10.7,14.3,15.78.81.88,4.72,5.5,4.93,4.93-1.55-2.27-1.12-5.32-1.97-8.38-2.26-8.1-4.59-17.58-4.93-27.12h-.99c-2.5-1.65-6.39-1.39-9.37-2.47-6.29-2.28-13.14-4.97-18.74-8.38-19.02-11.58-32.89-26.18-41.92-47.84-3.34-8.01-3.44-16.8-6.41-25.64h8.88c3.13,1.98,8.71,1.3,12.33,2.47,5.57,1.79,11.55,4.41,16.27,7.4,19.28,12.2,24.13,29.87,32.55,52.77,1.97,5.26,3.95,10.52,5.92,15.78h.49v-3.45c-2.11-3.37-.03-9.3-.99-13.81-2.61-12.29.41-27.3.49-39.45-8.42-1.96-13.39-7.43-19.23-11.84-11.14-8.4-20.03-21.72-25.64-35.51-2.15-5.29-2.4-10.23-3.95-16.27-1.74-6.82-1.97-14.84-1.97-23.67,0-3.44-.44-7.8.99-9.86,1.46,1.03,3.57.74,5.42,1.48,4.05,1.62,8.63,3.63,12.33,5.92,12.19,7.56,20.9,18.99,26.63,33.04,3.72,9.12,4.11,20.16,6.41,30.58.85,3.87-.9,9.78.99,12.82.31-5.89,2.02-12.2,3.45-17.26,1.81-6.39,1.93-12.04,3.95-18.25.74-2.28,4.42-10.37,3.45-11.83-3.91-3.73-9.07-5.98-12.33-10.36-7.67-10.29-14.1-22.34-18.25-36-1.53-5.05-.74-9.66-1.97-15.29-1.77-8.08-.36-31.78,2.96-36.49.58-.4.83-.38,1.97-.49,2.11,1.68,5.03,2.01,7.4,3.45,4.71,2.87,10.54,7.48,13.81,11.84,4.97,6.62,8.84,14.63,11.34,23.67.66,4.77,1.32,9.54,1.97,14.3,1.92,8.91-.9,20.4-.99,28.6h.49v-.99c3.35-4.52,5.01-12.77,7.4-18.25,4.3-9.87,9.65-19.58,14.3-29.1-5.35-1.41-9.01-5.81-12.33-9.37-9.25-9.93-13.46-21.72-17.26-37.48-.16-2.96-.33-5.92-.49-8.88-1.27-5.96-.54-14.71.99-20.22,1.97-7.1,4.58-14.28,8.38-19.73,1.23-1.76,3.22-3.11,4.44-4.93.16.16.33.33.49.49,10.73,5.47,19.67,21.11,23.67,33.53,1.04,3.24.64,5.82,1.48,9.37,1.2,5.04,2.4,15.72.99,22.19-.82,5.1-1.64,10.19-2.47,15.29-.93,3.36-2.44,7.12-2.96,10.85h.49v-.99c2.87-2.89,4.2-7.29,6.41-10.85,4.41-7.09,9.13-14.18,13.81-21.21,2.49-3.74,7.71-7.7,8.38-12.82-3.03-3.22-3.76-8.76-5.42-13.32-6.79-18.55-7.97-47.84,0-66.08,1.79-4.1,7.03-12.24,10.36-14.79,2.42-1.86,5.27-3.27,7.4-5.43.87.31.48.1.99.49,3.42,3.61,3.83,10.39,5.43,15.78,8.39,28.3-1.65,54.36-11.34,74.47h.49c4.38-7.51,11.17-13.42,16.27-20.22,5.46-7.27,11.13-15.07,17.75-21.21-.99-2.63-1.97-5.26-2.96-7.89-1.6-4.96-1.83-10.64-2.96-15.78-1.16-5.31-1.09-16.68,0-21.7,1.03-4.72-.15-8.56.99-12.82,3-11.26,7.01-20.03,12.82-28.11,3.37-4.69,6.98-9.67,12.33-12.33,1.53,5.75,3.45,12.1,4.93,18.74.16,4.77.33,9.53.49,14.3,0,23.87-6.57,39.01-15.29,53.75h.49v-.49c3.85-2.64,7.52-7.59,10.36-11.34,4.11-3.78,8.22-7.56,12.33-11.34,2-2.9,2.94-6.04,4.93-8.88,8.83-12.58,20.59-24.54,33.53-33.04,5.93-3.9,12.69-6.87,20.71-8.88,2.96-.16,5.92-.33,8.88-.49.79-.17,2.89-.82,4.44-.49,6.12,1.3,12.35,2.29,17.75,3.45.26.75.33.83.49,1.97-3.46,3.68-5.41,9.25-8.38,13.31-7.35,10.03-24.13,25.91-36,31.07-8.25,3.59-35.24,8.86-46.85,6.41-2.48.98-8.13,7.57-9.86,9.86-2.3,2.14-4.6,4.27-6.9,6.41-2.88,3.82-5.99,7.02-8.88,10.85-1.89,2.51-5.25,4.15-6.41,7.4h.49c2.66-3.7,8.12-5.7,12.33-7.89,12.15-6.32,33.02-13.94,52.27-9.37,6.71,1.6,19.66,2.46,22.19,7.4h-.49c-1.9,5.21-9.37,8.92-13.81,11.84-8.16,5.36-17.03,9-28.11,11.84-4.79,1.22-9.45-.16-14.79.99-3.71.79-12.03.96-16.27,0-4.44-.82-8.88-1.64-13.31-2.47-2.85-.93-5.38-2.62-8.88-2.96-8.5,13.33-20.79,24.25-29.1,37.97h.99c2.91-4.05,8.45-5.73,12.82-8.38,9.11-5.54,33.76-14.03,50.3-9.86,7.13,1.79,12.87,4.59,18.74,7.4-6.26,9.81-18.6,17.23-30.58,21.21-4.97,1.65-9.14,1.22-14.79,2.47-6.39,1.41-17.59,2.14-24.66.49-3.62-.82-7.23-1.64-10.85-2.47-2.63-.97-4.69-2.49-7.89-2.96-2.81,5.85-7.46,10.9-10.85,16.27-6.69,10.6-12.67,22.12-17.75,34.03h.49c3.1-4.84,7.76-8.43,12.33-11.83,19.02-14.16,46.64-30.4,77.42-16.27-8.9,15.06-22.97,28.58-39.95,35.51-4.16,1.7-8.11,1.72-12.82,2.96-5.88,1.55-16.61,3.72-24.66,1.97-5.59-.99-11.18-1.97-16.77-2.96-5.84,13.71-10.32,28.26-16.27,42.41h.49v-.49c3.61-4.11,7.23-8.22,10.85-12.33,13.12-9.93,25.41-18.64,43.89-23.67,7.7-2.1,18.58-.98,25.15.99,2.57.77,5.67.39,6.9,2.47-1.96,2.04-2.84,4.99-4.44,7.4-2.7,4.06-5.92,7.91-8.88,11.84-2.25,2.98-5.85,5.62-8.88,7.89-3.23,2.42-6.33,5.71-9.86,7.89-9.11,5.63-20.88,7.21-33.04,9.86-8.7,1.9-18.53-.98-25.64-1.48v.99c-2.89,4.24-2.83,10.95-4.44,16.27-3.7,12.23-6.64,26.92-6.9,41.92h.49v-.49c5.78-5.79,9.06-14.42,13.81-21.21,11.23-16.03,24.28-30.2,46.36-35.51,8.17-1.96,18.06,1.32,26.14,1.48v.99c-2.37,2.52-3.07,6.32-4.93,9.37-2.46,4.03-5.11,8.36-7.89,12.33-15.32,21.83-37.15,36.46-74.47,36.49h0ZM1362.19,628.81c24.32.03,37.31,16.26,44.38,33.53,3.01,7.36,3.34,15.27,5.92,23.18,1.29,3.96,3.43,8.1,4.44,12.33.16-.16.33-.33.49-.49,2.94-2.98,4.14-7.14,6.41-10.85,4.26-6.97,7.84-14.19,11.34-22.19,1.3-2.97,3.36-5.52,3.95-9.37h-.99c-2.77-1.82-7.21-1.06-10.85-1.97-4.65-1.17-9.95-2.11-14.3-3.95-21.38-9.03-40.03-36.09-45.37-61.15h.99c2.67,1.63,7.39.21,10.85.99,6.4,1.43,12.82,2.46,18.25,4.93,16.9,7.72,25.07,25.59,33.53,41.92,2.71,5.22,7.06,10.68,8.88,16.27.16-.16.33-.33.49-.49,2.9-3.87,3.27-9.77,4.93-14.79,2.65-8.01,6.01-17.34,6.41-27.12-33.34.16-50.79-17.91-64.11-37.97-4.41-6.65-12.08-17.55-13.32-26.63,8.79-.05,18.08-.65,25.15,1.48,19.91,5.99,30.9,22.01,40.93,37.97,3.83,6.09,9.55,13.04,11.84,20.22h.49c.68-6.09,1.14-13.59,2.47-19.73.69-3.21-.07-7.76.49-10.36-.16-7.56-.33-15.13-.49-22.69-38.28.44-58.9-15.29-74.46-37.48-4.39-6.26-10.68-13.54-12.82-21.7h3.45c6.31-4.09,26.72-.6,32.05,1.48,19.38,7.54,29.7,22.79,40.44,38.96,3.29,4.96,7.6,9.91,10.36,15.29h.49v-4.44c-.82-6.25-1.64-12.49-2.47-18.74-3.03-12.23-6.22-24.32-8.88-36h-1.97c-4.95,3.28-25.06,1.36-30.58,0-6.21-1.53-11.34-1.72-16.77-3.95-13.88-5.7-24.35-15.19-32.55-26.63-2.98-4.16-7.43-8.24-8.88-13.81,5.08-.66,10.57-2.17,15.78-3.45,5.29-1.3,12.57.38,16.27,1.48,13.06,3.88,23.27,7.46,33.04,14.3,6.3,4.41,11.93,10.33,17.26,15.78.79.81,4.61,6.3,4.93,5.42-1.76-2.43-1.72-5.86-2.96-8.88-2.88-7-5.94-14.76-8.88-21.7-1.49-3.53-2.04-10.8-6.41-11.34-5.08,3.64-26.06,3.69-33.53,1.97-6.97-1.61-12.82-1.52-18.74-3.95-16.87-6.92-31.16-20.45-39.95-35.51,24.76-10.23,50.15-2.75,68.55,8.88,5.87,3.71,11.9,8.94,16.77,13.81.8.81,4.59,5.75,4.93,4.93-3.97-5.23-5.69-12.38-8.88-18.24-3.65-6.73-8.18-13.43-12.33-19.73-2.01-3.06-5.42-11.35-9.37-11.84-5.31,5.12-22.47,6.3-33.53,5.92-22.29-.76-44.83-10.33-53.26-24.66,5.89-2.85,11.5-5.64,18.74-7.4,4.49-1.09,12.42-.97,16.77,0,6.13,1.37,11.3.69,16.77,2.47,12.14,3.94,21.16,10.03,30.57,16.27v-.99c-3.35-2.68-5.36-7.32-7.89-10.85-4.04-5.61-9.21-10.75-13.32-16.27-2.38-3.22-5.07-9.8-9.86-10.36-4.15,3.8-13.92,4.05-20.22,5.42h-6.91c-2.64.54-7.22.39-9.86,0-3.78-.16-7.56-.33-11.34-.49-14.31-3.4-24.55-7.62-34.52-14.79-3.78-2.72-9.31-5.53-10.85-10.36,6-1.65,11.89-4.75,18.74-6.41,5.38-1.3,13.78-1.69,19.23-.49,7.83,1.72,14.46.76,21.21,2.96,10.88,3.55,19.5,9.24,28.11,14.79v-.99c-4.06-2.69-7.42-7.95-10.36-11.84-3.95-3.95-7.89-7.89-11.84-11.84-1.49-1.96-7.8-9.25-9.86-9.86-2.61-.77-11.16.92-15.29,0-6.9-.99-13.81-1.97-20.71-2.96-19.62-5.91-33.52-17.93-44.38-32.55-3.61-4.85-9.76-9.64-10.85-16.77.16-.16.33-.33.49-.49,2.96-.82,5.92-1.64,8.88-2.47,2.87-.76,6.35-.38,8.88-.99,6.47-1.56,18.03,2.33,22.19,3.95,19.17,7.44,35.65,24.5,46.36,40.44,1.72,2.57,2.62,5.37,4.44,7.89,5.09,5.09,10.19,10.19,15.29,15.29,1.03,1.03,6.57,7.17,6.9,6.41-3.09-3.26-4.48-7.89-6.41-12.33-4.75-10.93-11.89-32.26-7.89-49.81,1.61-7.06.74-21,5.92-23.67,3.19,4.72,9.33,8.34,12.82,13.31,6.64,9.45,9.34,20.64,12.33,34.03,1.95,8.73.51,29.98-1.48,37.48-.88,3.35-4.84,11.43-3.95,13.81,1.06,3.18,4.56,4.94,6.41,7.4,5.92,7.85,12.93,14.86,18.74,22.68,1.94,2.61,6.5,10.8,8.88,10.85-3.56-3.84-4.73-10.1-6.9-15.29-9.73-23.18-9.79-52.39.99-74.96.87.31.48.1.99.49,4.79,1.54,8.61,6.59,11.34,10.36,1.85,2.55,4.56,5.39,5.92,8.38,6.28,13.8,8.9,38.38,3.94,56.22-1.31,4.6-2.63,9.21-3.94,13.81-1.6,3.9-4.44,7.48-4.93,12.33,4.09,2.98,6.53,9.04,9.37,13.31,5.03,7.56,9.83,15.19,14.79,23.18,1.47,2.36,3.57,4.39,4.44,7.4h.49v-1.48c-3.3-4.25-3-14.36-4.44-20.71-5.54-24.55,4.61-46.77,14.3-59.67,2.89-3.85,7.9-6.1,10.85-9.86.16.16.33.33.49.49,3.03,1.99,3.98,4.76,5.92,7.89,13.08,21.2,9.01,57.88-3.95,76.44-2.74,3.93-7.01,8.99-10.85,11.84-2.25,1.67-6.12,2.32-6.9,5.42,3.09,3.42,4.25,8.48,6.41,12.82,5.19,10.42,11.8,22.03,14.79,34.03h.49v-3.95c-1.84-2.89-1.37-20.63-.49-24.66,1.62-7.41.82-13.36,2.96-19.73,5.59-16.64,16.99-27.72,33.04-34.03v.99c3.31,4.59,4.72,28.51,2.96,36.49-1.24,5.63-.45,10.23-1.97,15.29-5.09,16.88-16.28,39.51-31.07,46.36,3.98,10.69,6.31,23.02,9.37,34.52,1.12,4.23.17,10.16,2.47,13.31-.44-35.86,11.47-63.27,33.53-76.93,5.47-3.38,11.72-5.02,18.25-7.4,3.12,38.48-7.97,58.11-23.67,78.9-4.22,5.58-11.73,11.07-17.75,14.79-1.32.82-8.33,2.71-8.88,3.45v6.41c1.14,1.81-.05,5.34.49,7.89,2.85,13.46-.76,29.58-.99,42.41h.49v-.99c5.13-6.58,7.29-22.4,10.85-31.07,10.57-25.76,28.6-46.62,65.1-46.36v.49c-1.65,2.62-1.02,7.16-1.97,10.36-2.24,7.51-4.39,14.81-7.4,21.7-10.96,25.09-38.19,45.49-68.05,51.78v2.96c-1.94,3.18-.96,8.36-1.97,12.33-1.7,6.69-3.36,14.11-4.93,20.71h.49c10.18-17.06,35.04-36.65,55.73-43.4,11.9-3.89,29.15-1.93,37.97,2.96-16.28,28.01-50.81,55.58-95.67,45.37v.99c-1.97,5.59-3.95,11.18-5.92,16.77-3.34,7.71-7.71,15.28-11.34,22.69h.49c3.08-4.45,8.85-7.22,13.31-10.36,12.51-8.79,25.2-14.56,42.9-18.74,13.71-3.23,27.54,2.79,35.01,7.89,2.76,1.89,6.65,3.59,7.4,7.4-5.13,3.33-9.2,8.76-14.3,12.33-4.45,3.11-9.07,5.11-14.3,7.4-16.75,7.34-44.38,15.91-64.6,5.43-3.44-1.79-6.82-2.8-8.88-5.92h-.49c-1.62,5.25-6.05,9.56-8.88,13.81-5.16,7.73-10.3,14.85-15.78,22.19-3.99,5.34-9.65,9.62-13.31,15.29h.49c3.21-4.43,9.56-6.91,14.3-9.86,12.79-7.96,37.89-20.76,60.66-13.31,4.9,1.6,9.93,4.07,13.81,6.9,2.14,2.3,4.27,4.6,6.41,6.9-2.64,5.03-8.66,8.24-13.32,11.34-11.93,7.94-25.03,12.77-41.42,16.77-17.15,4.18-40.09-4.46-45.86-13.31-.16.16-.33.33-.49.49-7.73,7.72-15.45,15.45-23.18,23.18-3.86,3.78-9.31,6.79-12.33,11.34h.49c3.98-3.17,10.46-3.71,15.78-5.42,22.01-7.08,57.88-7.82,70.03,8.88,1.94,2.67,4.09,4.43,4.44,8.88-4.93,1.39-10.07,4.73-15.29,6.41-15.55,5.02-44.5,5.51-59.18-.49-6.06-2.48-13.16-6.83-16.77-11.84-1.03-1.43-1.3-3.19-2.47-4.44v.49c-4.75,2.95-8.39,7.59-12.82,10.85-7.52,5.53-15.12,10.21-23.18,15.29-3.06,1.93-5.99,4.8-9.86,5.92v.49h1.48c4.52-3.5,16.36-2.94,23.18-4.44,28.93-6.36,60.85,6.36,65.59,27.62-2.48.68-4.64,2.21-6.9,2.96-4.6.99-9.21,1.97-13.81,2.96-5.85,1.3-16.03,1.24-21.7,0-5.39-1.18-9.93-.13-14.79-1.48-16.65-4.62-30.16-11.28-37.97-24.66-.87.31-.48.1-.99.49-7.18,1.69-15.42,8.33-22.19,11.34-11.65,5.17-22.98,9.2-35.01,14.3-6.75,2.86-14.23,6.41-21.7,8.38-1.48-3.95-2.96-7.89-4.44-11.84,5.09-.99,9.91-3.59,14.3-5.42,15.81-6.6,31.01-12.22,45.37-19.73,6.8-3.55,17.69-7.16,22.69-12.33h-.99c-3.8-5.61-8.9-9.94-11.84-16.77-5.4-12.56-5.66-34.38-1.48-48.33,1.38-4.61,2.85-14.43,6.41-16.27,1.05.68,2.61.43,3.95.99,4.27,1.77,8.94,5.68,11.34,9.37,8.01,12.28,8.08,38.86,2.96,54.74-1.43,4.43-3.72,8.91-4.93,13.32h.49c2.65-3.27,7.79-5.02,11.34-7.4,5.88-3.94,11.17-9.15,16.77-13.32,3.21-2.39,8.95-5.39,10.36-9.37-4.7-1.28-7.8-5.36-10.36-8.88-7.56-10.39-15.66-29.75-11.34-48.33,1.61-6.93,2.68-24.68,9.37-25.15,2.13,1.66,5.08,1.93,7.4,3.45,3.86,2.53,7.94,7.36,10.36,11.34,10.22,16.87,4.07,51.34-2.96,66.08h.49c1.92-2.88,5-4.51,7.4-6.9,7.97-7.94,16.86-15.64,23.67-24.66,2.31-3.05,6.98-5.02,7.89-9.37-4.79-1.67-8.49-6.53-12.33-9.37-18.95-14.02-25.51-32.35-25.64-65.1h.99c3.7,2.64,9.49,2.58,13.32,4.93,10.5,6.46,17.57,17.82,21.7,30.57,2.79,8.62-.13,31.87,3.94,37.97,4.2-6.79,10.71-12.25,15.29-18.74,3.87-5.48,7.05-12.64,11.84-17.26v-.49c-4.2-1-7.75-3.38-11.34-4.93-20.55-8.89-28.73-24.64-36-46.85-1.99-6.07-5.47-12.46-6.41-19.23h0Z';

/**
 * MUI Laurel Creator Modal
 * - Left/Right SVG laurel wreath
 * - Editable, multi-line center text
 * - Draggable center-text group inside the preview (overlay Box)
 * - Controls: font size, family, letter spacing, line height, color
 * - Download SVG / PNG with embedded text
 * - FIX: Handle CSS (preview) vs SVG (export) coordinate spaces
 */

const BackdropBox = styled(Box)(({ theme }) => ({
    position: 'fixed',
    inset: 0,
    display: 'grid',
    placeItems: 'center',
    backdropFilter: 'blur(2px)',
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
}));

const ModalCard = styled(Paper)(({ theme }) => ({
    width: 980,
    maxWidth: '95vw',
    maxHeight: '92vh',
    overflow: 'hidden',
    borderRadius: 16,
    boxShadow: theme.shadows[12],
    display: 'grid',
    gridTemplateRows: 'auto 1fr auto',
}));

const Header = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`,
}));

const Content = styled(Box)(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: '360px 1fr',
    minHeight: 480,
    overflow: 'hidden',
}));

const Controls = styled(Box)(({ theme }) => ({
    padding: theme.spacing(2),
    overflow: 'auto',
    borderRight: `1px solid ${theme.palette.divider}`,
}));

const Preview = styled(Box)(({ theme }) => ({
    padding: theme.spacing(2),
    display: 'grid',
    placeItems: 'center',
    background: theme.palette.mode === 'dark' ? '#0d0f12' : '#fafafa',
}));

const Aspect = styled(Box)(({ theme }) => ({
    width: '100%',
    maxWidth: 720,
    aspectRatio: '4 / 3',
    background: theme.palette.background.paper,
    borderRadius: 12,
    boxShadow: theme.shadows[3],
    overflow: 'hidden',
    position: 'relative',
}));

function splitLines(text: string) {
    return text.replace(/\r/g, '').split('\n');
}

interface DraggableTextProps {
    text: string;
    fontFamily: string;
    fontSize: number;
    letterSpacing: number; // px
    lineHeight: number;
    textColor: string;
    position: { x: number; y: number }; // CSS px for overlay
}

/**
 * CHANGED: DraggableText now forwardRef so we can measure its actual rendered box.
 */
const DraggableText = React.forwardRef<HTMLDivElement, DraggableTextProps>(function DraggableText(
    { text, fontFamily, fontSize, letterSpacing, lineHeight, textColor, position },
    forwardedRef,
) {
    const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
        id: 'draggable-text',
    });

    const style = {
        transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
        opacity: isDragging ? 0.5 : 1,
    };

    const lines = useMemo(() => splitLines(text), [text]);

    return (
        <Box
            ref={(node: any) => {
                setNodeRef(node);
                if (typeof forwardedRef === 'function') forwardedRef(node);
                else if (forwardedRef) (forwardedRef as React.MutableRefObject<HTMLDivElement | null>).current = node;
            }}
            style={style}
            {...listeners}
            {...attributes}
            sx={{
                position: 'absolute',
                left: position.x,
                top: position.y,
                width: 440,
                textAlign: 'center',
                cursor: isDragging ? 'grabbing' : 'grab',
                userSelect: 'none',
                color: textColor,
                fontFamily,
                fontSize, // CSS preview
                letterSpacing, // CSS preview (px)
                lineHeight,
                fontWeight: 700,
                zIndex: 10,
                '&:hover': { opacity: 0.8 },
            }}
            title="Drag to move">
            {lines.map((line, i) => (
                <div key={i}>{line}</div>
            ))}
        </Box>
    );
});

interface LaurelCreatorModalProps {
    open: boolean;
    onClose: () => void;
    onSave?: (laurelData: any) => void;
}

export const LaurelCreatorModal: React.FC<LaurelCreatorModalProps> = ({ open, onClose, onSave }) => {
    const { themeStyle } = useThemeContext();
    const currentTheme = theme[themeStyle];

    // Text controls
    const [centerText, setCenterText] = useState('OFFICIAL SELECTION\nTHSPIAN FILM FESTIVAL\n2025');
    const [fontFamily, setFontFamily] = useState("'Playfair Display', serif");
    const [fontSize, setFontSize] = useState(34);
    const [letterSpacing, setLetterSpacing] = useState(1);
    const [lineHeight, setLineHeight] = useState(1.15);
    const [textColor, setTextColor] = useState('#111111');

    // Laurel controls
    const [strokeWidth, setStrokeWidth] = useState(3);
    const [wreathColor, setWreathColor] = useState('#111111');
    const [laurelPosition, setLaurelPosition] = useState({ x: 130, y: 50 });
    const [laurelScale, setLaurelScale] = useState(0.45);

    // Draggable position deltas in CSS px for the overlay Box
    const [dragPos, setDragPos] = useState({ x: 0, y: 0 });

    // ViewBox size - matching the ThspianLaurel.svg dimensions
    const view = { w: 1920, h: 1080 };

    // Refs for measurement
    const svgRef = useRef<SVGSVGElement | null>(null);
    const dragRef = useRef<HTMLDivElement | null>(null); // <-- NEW

    // Helpers to compute scale factors CSS->SVG
    const getSvgScale = () => {
        const el = svgRef.current;
        if (!el) return { sx: 1, sy: 1 };
        const rect = el.getBoundingClientRect();
        return {
            sx: view.w / rect.width,
            sy: view.h / rect.height,
        };
    };

    // Base anchor (SVG units) for overlay group (starting center area)
    const baseSvgX = view.w / 2 - 220; // visual starting left for 440px box
    const baseSvgY = view.h / 2 - 40;

    // CSS position for the overlay Box (what you see and drag)
    const getTextPositionCss = () => {
        const { sx, sy } = getSvgScale();
        return {
            x: baseSvgX / sx + dragPos.x,
            y: baseSvgY / sy + dragPos.y,
        };
    };

    /**
     * CHANGED: Measure the draggable’s actual visual center in CSS pixels and map to SVG units.
     * This removes assumptions about fixed left edges or widths during export.
     */
    const getTextPositionSvg = () => {
        const svg = svgRef.current;
        const el = dragRef.current;
        if (!svg || !el) {
            // fallback: center
            return { x: view.w / 2, y: view.h / 2 };
        }

        const svgRect = svg.getBoundingClientRect();
        const elRect = el.getBoundingClientRect();

        // center of the draggable in CSS pixels relative to SVG
        const cxCss = elRect.left + elRect.width / 2 - svgRect.left;
        const cyCss = elRect.top + elRect.height / 2 - svgRect.top;

        // convert CSS -> SVG units
        const { sx, sy } = getSvgScale();
        return { x: cxCss * sx, y: cyCss * sy };
    };

    const sensors = useSensors(
        useSensor(PointerSensor, {
            activationConstraint: { distance: 8 },
        }),
    );

    const handleDragEnd = (event: DragEndEvent) => {
        const { delta } = event; // CSS px
        setDragPos(prev => ({
            x: prev.x + delta.x,
            y: prev.y + delta.y,
        }));
    };

    // --- Downloads (SVG / PNG) ---

    /**
     * CHANGED: Inject text centered at the measured point (no magic 220).
     * Also set letter-spacing with px units to match preview.
     * Block is vertically centered around the anchor (dominant-baseline handled via y math).
     */
    const injectTextGroupIntoSvgClone = (svgClone: SVGElement) => {
        const lines = splitLines(centerText);
        const { x: cx, y: cy } = getTextPositionSvg(); // SVG units
        const { sx } = getSvgScale();

        const textGroup = document.createElementNS('http://www.w3.org/2000/svg', 'g');
        textGroup.setAttribute('transform', `translate(${cx}, ${cy})`);
        textGroup.setAttribute('text-anchor', 'middle');

        // Convert CSS font size to SVG units
        const svgFontSize = fontSize * sx; // scale font size to match SVG coordinate system
        const lh = svgFontSize * lineHeight; // line step in SVG units
        const yStart = -((lines.length - 1) * lh) / 2; // vertical centering of the block

        lines.forEach((line, index) => {
            const textElement = document.createElementNS('http://www.w3.org/2000/svg', 'text');
            textElement.setAttribute('x', '0');
            textElement.setAttribute('y', `${yStart + index * lh}`);
            textElement.setAttribute('fill', textColor);
            textElement.setAttribute('font-family', fontFamily);
            textElement.setAttribute('font-size', svgFontSize.toString());
            textElement.setAttribute('font-weight', '700');
            textElement.setAttribute('letter-spacing', `${letterSpacing * sx}px`); // scale letter spacing too
            textElement.textContent = line;
            textGroup.appendChild(textElement);
        });

        svgClone.appendChild(textGroup);
    };

    const handleDownloadSVG = () => {
        const svgEl = document.getElementById('laurel-svg') as SVGElement | null;
        if (!svgEl) return;

        const svgClone = svgEl.cloneNode(true) as SVGElement;
        injectTextGroupIntoSvgClone(svgClone);

        const serializer = new XMLSerializer();
        const svgString = serializer.serializeToString(svgClone);
        const blob = new Blob([svgString], { type: 'image/svg+xml;charset=utf-8' });
        const url = URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = 'laurel.svg';
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
    };

    const handleDownloadPNG = () => {
        const svgEl = document.getElementById('laurel-svg') as SVGElement | null;
        if (!svgEl) return;

        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) return;

        // Optional: render HiDPI by multiplying (e.g., 2x)
        const scale = 1; // set to 2 for retina export if you want
        canvas.width = view.w * scale;
        canvas.height = view.h * scale;

        const svgClone = svgEl.cloneNode(true) as SVGElement;
        (svgClone as any).style = (svgClone as any).style || {};
        (svgClone as any).style.backgroundColor = 'transparent';

        injectTextGroupIntoSvgClone(svgClone);

        const svgData = new XMLSerializer().serializeToString(svgClone);
        const svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
        const svgUrl = URL.createObjectURL(svgBlob);

        const img = new Image();
        img.onload = () => {
            ctx.setTransform(scale, 0, 0, scale, 0, 0);
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(img, 0, 0);
            canvas.toBlob(blob => {
                if (blob) {
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = 'laurel.png';
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    URL.revokeObjectURL(url);
                }
                URL.revokeObjectURL(svgUrl);
            }, 'image/png');
        };
        img.src = svgUrl;
    };

    // --- Save (store SVG-space position for perfect rehydration) ---

    const handleSave = () => {
        if (onSave) {
            const svgEl = svgRef.current;
            if (svgEl) {
                const serializer = new XMLSerializer();
                const svgString = serializer.serializeToString(svgEl);
                const posSvg = getTextPositionSvg(); // <-- measured point in SVG units
                onSave({
                    svgData: svgString, // base without embedded text (your choice)
                    config: {
                        centerText,
                        fontFamily,
                        fontSize,
                        letterSpacing,
                        lineHeight,
                        textColor,
                        strokeWidth,
                        wreathColor,
                        positionSvg: posSvg, // store SVG units
                    },
                    timestamp: new Date().toISOString(),
                });
            }
        }
        onClose();
    };

    return (
        <Modal open={open} onClose={onClose}>
            <BackdropBox>
                <ModalCard
                    sx={{
                        backgroundColor: currentTheme.secondaryBg,
                        border: `1px solid ${currentTheme.selectableBorder}`,
                    }}>
                    <Header sx={{ borderBottom: `1px solid ${currentTheme.selectableBorder}` }}>
                        <Typography
                            variant="h6"
                            fontWeight={700}
                            sx={{ fontFamily: FONT_ENUM.MAIN_BOLD, color: currentTheme.tag_white }}>
                            Laurel Creator
                        </Typography>
                        <Stack direction="row" spacing={1} alignItems="center">
                            <Button
                                onClick={handleDownloadSVG}
                                startIcon={<DownloadIcon />}
                                variant="outlined"
                                size="small"
                                sx={{
                                    borderColor: currentTheme.highlight,
                                    color: currentTheme.highlight,
                                    '&:hover': {
                                        borderColor: currentTheme.primary_orange,
                                        backgroundColor: currentTheme.primary_orange,
                                        color: currentTheme.true_white,
                                    },
                                }}>
                                SVG
                            </Button>
                            <Button
                                onClick={handleDownloadPNG}
                                startIcon={<DownloadIcon />}
                                variant="outlined"
                                size="small"
                                sx={{
                                    borderColor: currentTheme.highlight,
                                    color: currentTheme.highlight,
                                    '&:hover': {
                                        borderColor: currentTheme.primary_orange,
                                        backgroundColor: currentTheme.primary_orange,
                                        color: currentTheme.true_white,
                                    },
                                }}>
                                PNG
                            </Button>
                            <IconButton
                                onClick={onClose}
                                sx={{
                                    color: currentTheme.tag_white,
                                    '&:hover': {
                                        backgroundColor: currentTheme.primary_orange,
                                        color: currentTheme.true_white,
                                    },
                                }}>
                                <CloseIcon />
                            </IconButton>
                        </Stack>
                    </Header>

                    <Content>
                        <Controls
                            sx={{
                                backgroundColor: currentTheme.form_background,
                                borderRight: `1px solid ${currentTheme.selectableBorder}`,
                            }}>
                            <Stack spacing={2}>
                                <Typography
                                    variant="overline"
                                    sx={{
                                        fontFamily: FONT_ENUM.MAIN_REGULAR,
                                        color: currentTheme.tag_white,
                                        fontSize: '0.75rem',
                                        fontWeight: 600,
                                    }}>
                                    Center Text
                                </Typography>
                                <TextField
                                    label="Text (multi-line)"
                                    value={centerText}
                                    onChange={e => setCenterText(e.target.value)}
                                    multiline
                                    minRows={6}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            color: currentTheme.tag_white,
                                            '& fieldset': { borderColor: currentTheme.selectableBorder },
                                            '&:hover fieldset': { borderColor: currentTheme.highlight },
                                            '&.Mui-focused fieldset': { borderColor: currentTheme.highlight },
                                        },
                                        '& .MuiInputLabel-root': { color: currentTheme.form_label },
                                    }}
                                />

                                <FormControl fullWidth>
                                    <InputLabel sx={{ color: currentTheme.form_label }}>Font Family</InputLabel>
                                    <Select
                                        label="Font Family"
                                        value={fontFamily}
                                        onChange={e => setFontFamily(e.target.value)}
                                        sx={{
                                            color: currentTheme.tag_white,
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                borderColor: currentTheme.selectableBorder,
                                            },
                                            '&:hover .MuiOutlinedInput-notchedOutline': {
                                                borderColor: currentTheme.highlight,
                                            },
                                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                borderColor: currentTheme.highlight,
                                            },
                                        }}>
                                        <MenuItem value="'Playfair Display', serif">Playfair Display</MenuItem>
                                        <MenuItem value="'Cinzel', serif">Cinzel</MenuItem>
                                        <MenuItem value="'Cormorant Garamond', serif">Cormorant Garamond</MenuItem>
                                        <MenuItem value="'Montserrat', sans-serif">Montserrat</MenuItem>
                                        <MenuItem value="'Inter', sans-serif">Inter</MenuItem>
                                    </Select>
                                </FormControl>

                                <Typography
                                    variant="caption"
                                    sx={{ fontFamily: FONT_ENUM.MAIN_REGULAR, color: currentTheme.tag_white }}>
                                    Font Size
                                </Typography>
                                <Slider
                                    value={fontSize}
                                    min={16}
                                    max={72}
                                    step={1}
                                    valueLabelDisplay="auto"
                                    onChange={(_, v) => setFontSize(v as number)}
                                    sx={{
                                        color: currentTheme.highlight,
                                        '& .MuiSlider-thumb': { backgroundColor: currentTheme.highlight },
                                    }}
                                />

                                <Typography
                                    variant="caption"
                                    sx={{ fontFamily: FONT_ENUM.MAIN_REGULAR, color: currentTheme.tag_white }}>
                                    Letter Spacing
                                </Typography>
                                <Slider
                                    value={letterSpacing}
                                    min={0}
                                    max={5}
                                    step={0.1}
                                    valueLabelDisplay="auto"
                                    onChange={(_, v) => setLetterSpacing(v as number)}
                                    sx={{
                                        color: currentTheme.highlight,
                                        '& .MuiSlider-thumb': { backgroundColor: currentTheme.highlight },
                                    }}
                                />

                                <Typography
                                    variant="caption"
                                    sx={{ fontFamily: FONT_ENUM.MAIN_REGULAR, color: currentTheme.tag_white }}>
                                    Line Height
                                </Typography>
                                <Slider
                                    value={lineHeight}
                                    min={1}
                                    max={2}
                                    step={0.01}
                                    valueLabelDisplay="auto"
                                    onChange={(_, v) => setLineHeight(v as number)}
                                    sx={{
                                        color: currentTheme.highlight,
                                        '& .MuiSlider-thumb': { backgroundColor: currentTheme.highlight },
                                    }}
                                />

                                <Divider sx={{ my: 1, borderColor: currentTheme.selectableBorder }} />

                                <Typography
                                    variant="overline"
                                    sx={{
                                        fontFamily: FONT_ENUM.MAIN_REGULAR,
                                        color: currentTheme.tag_white,
                                        fontSize: '0.75rem',
                                        fontWeight: 600,
                                    }}>
                                    Colors
                                </Typography>
                                <Stack direction="row" spacing={2} alignItems="center">
                                    <Box>
                                        <Typography
                                            variant="caption"
                                            sx={{
                                                fontFamily: FONT_ENUM.MAIN_REGULAR,
                                                color: currentTheme.tag_white,
                                                display: 'block',
                                                mb: 1,
                                            }}>
                                            Text
                                        </Typography>
                                        <input
                                            aria-label="Text color"
                                            type="color"
                                            value={textColor}
                                            onChange={e => setTextColor(e.target.value)}
                                            style={{
                                                width: 48,
                                                height: 32,
                                                border: 'none',
                                                background: 'transparent',
                                                borderRadius: 4,
                                                cursor: 'pointer',
                                            }}
                                        />
                                    </Box>
                                    <Box>
                                        <Typography
                                            variant="caption"
                                            sx={{
                                                fontFamily: FONT_ENUM.MAIN_REGULAR,
                                                color: currentTheme.tag_white,
                                                display: 'block',
                                                mb: 1,
                                            }}>
                                            Laurels
                                        </Typography>
                                        <input
                                            aria-label="Laurel color"
                                            type="color"
                                            value={wreathColor}
                                            onChange={e => setWreathColor(e.target.value)}
                                            style={{
                                                width: 48,
                                                height: 32,
                                                border: 'none',
                                                background: 'transparent',
                                                borderRadius: 4,
                                                cursor: 'pointer',
                                            }}
                                        />
                                    </Box>
                                </Stack>

                                <Typography
                                    variant="caption"
                                    sx={{ fontFamily: FONT_ENUM.MAIN_REGULAR, color: currentTheme.tag_white, mt: 1 }}>
                                    Laurel Stroke Width
                                </Typography>
                                <Slider
                                    value={strokeWidth}
                                    min={1}
                                    max={8}
                                    step={0.5}
                                    valueLabelDisplay="auto"
                                    onChange={(_, v) => setStrokeWidth(v as number)}
                                    sx={{
                                        color: currentTheme.highlight,
                                        '& .MuiSlider-thumb': { backgroundColor: currentTheme.highlight },
                                    }}
                                />

                                <Typography
                                    variant="caption"
                                    sx={{ fontFamily: FONT_ENUM.MAIN_REGULAR, color: currentTheme.tag_white, mt: 2 }}>
                                    Laurel Position X
                                </Typography>
                                <Slider
                                    value={laurelPosition.x}
                                    min={0}
                                    max={400}
                                    step={10}
                                    valueLabelDisplay="auto"
                                    onChange={(_, v) => setLaurelPosition(prev => ({ ...prev, x: v as number }))}
                                    sx={{
                                        color: currentTheme.highlight,
                                        '& .MuiSlider-thumb': { backgroundColor: currentTheme.highlight },
                                    }}
                                />

                                <Typography
                                    variant="caption"
                                    sx={{ fontFamily: FONT_ENUM.MAIN_REGULAR, color: currentTheme.tag_white, mt: 1 }}>
                                    Laurel Position Y
                                </Typography>
                                <Slider
                                    value={laurelPosition.y}
                                    min={0}
                                    max={300}
                                    step={10}
                                    valueLabelDisplay="auto"
                                    onChange={(_, v) => setLaurelPosition(prev => ({ ...prev, y: v as number }))}
                                    sx={{
                                        color: currentTheme.highlight,
                                        '& .MuiSlider-thumb': { backgroundColor: currentTheme.highlight },
                                    }}
                                />

                                <Typography
                                    variant="caption"
                                    sx={{ fontFamily: FONT_ENUM.MAIN_REGULAR, color: currentTheme.tag_white, mt: 1 }}>
                                    Laurel Scale
                                </Typography>
                                <Slider
                                    value={laurelScale}
                                    min={0.1}
                                    max={1.0}
                                    step={0.05}
                                    valueLabelDisplay="auto"
                                    onChange={(_, v) => setLaurelScale(v as number)}
                                    sx={{
                                        color: currentTheme.highlight,
                                        '& .MuiSlider-thumb': { backgroundColor: currentTheme.highlight },
                                    }}
                                />

                                <Divider sx={{ my: 1, borderColor: currentTheme.selectableBorder }} />

                                <Typography
                                    variant="overline"
                                    sx={{
                                        fontFamily: FONT_ENUM.MAIN_REGULAR,
                                        color: currentTheme.tag_white,
                                        fontSize: '0.75rem',
                                        fontWeight: 600,
                                    }}>
                                    Tip
                                </Typography>
                                <Typography
                                    variant="body2"
                                    sx={{ fontFamily: FONT_ENUM.MAIN_REGULAR, color: currentTheme.light_gray_text }}>
                                    Drag the center text in the preview to position it exactly where you want.
                                </Typography>
                            </Stack>
                        </Controls>

                        <Preview sx={{ background: currentTheme.form_background }}>
                            <Aspect
                                sx={{
                                    backgroundColor: currentTheme.true_white,
                                    border: `1px solid ${currentTheme.selectableBorder}`,
                                }}>
                                <DndContext
                                    sensors={sensors}
                                    collisionDetection={closestCenter}
                                    onDragEnd={handleDragEnd}>
                                    {/* SVG Drawing Surface */}
                                    <svg
                                        id="laurel-svg"
                                        ref={svgRef}
                                        width="100%"
                                        height="100%"
                                        viewBox={`0 0 ${view.w} ${view.h}`}
                                        xmlns="http://www.w3.org/2000/svg">
                                        <g
                                            transform={`translate(${laurelPosition.x},${laurelPosition.y}) scale(${laurelScale})`}>
                                            <path
                                                d={WRATHE_PATH}
                                                fill={wreathColor}
                                                stroke={wreathColor}
                                                strokeWidth={strokeWidth}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </g>
                                    </svg>

                                    {/* Draggable center text overlay using @dnd-kit (CSS coords) */}
                                    <DraggableText
                                        ref={dragRef}
                                        text={centerText}
                                        fontFamily={fontFamily}
                                        fontSize={fontSize}
                                        letterSpacing={letterSpacing}
                                        lineHeight={lineHeight}
                                        textColor={textColor}
                                        position={getTextPositionCss()}
                                    />
                                </DndContext>
                            </Aspect>
                        </Preview>
                    </Content>

                    <Box
                        sx={{
                            p: 1.5,
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            borderTop: `1px solid ${currentTheme.selectableBorder}`,
                        }}>
                        <Stack direction="row" spacing={1}>
                            <Button
                                variant="outlined"
                                onClick={handleDownloadSVG}
                                startIcon={<DownloadIcon />}
                                size="small"
                                sx={{
                                    borderColor: currentTheme.highlight,
                                    color: currentTheme.highlight,
                                    '&:hover': {
                                        borderColor: currentTheme.primary_orange,
                                        backgroundColor: currentTheme.primary_orange,
                                        color: currentTheme.true_white,
                                    },
                                }}>
                                Download SVG
                            </Button>
                            <Button
                                variant="outlined"
                                onClick={handleDownloadPNG}
                                startIcon={<DownloadIcon />}
                                size="small"
                                sx={{
                                    borderColor: currentTheme.highlight,
                                    color: currentTheme.highlight,
                                    '&:hover': {
                                        borderColor: currentTheme.primary_orange,
                                        backgroundColor: currentTheme.primary_orange,
                                        color: currentTheme.true_white,
                                    },
                                }}>
                                Download PNG
                            </Button>
                        </Stack>
                        <Stack direction="row" spacing={1}>
                            <Button
                                variant="text"
                                onClick={onClose}
                                sx={{
                                    color: currentTheme.tag_white,
                                    '&:hover': {
                                        backgroundColor: currentTheme.primary_orange,
                                        color: currentTheme.true_white,
                                    },
                                }}>
                                Close
                            </Button>
                            <Button
                                variant="contained"
                                onClick={handleSave}
                                sx={{
                                    backgroundColor: currentTheme.highlight,
                                    color: currentTheme.true_white,
                                    '&:hover': { backgroundColor: currentTheme.primary_orange },
                                }}>
                                Save to Library
                            </Button>
                        </Stack>
                    </Box>
                </ModalCard>
            </BackdropBox>
        </Modal>
    );
};
